<template>
    <div class="modal-background"></div>
    <div class="modal-container">

        <v-btn @click="$emit('close-modal')" variant="text" class="close">
            <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/34acc885-1b03-4a5a-b827-489477f81a78.svg"
                alt="">
        </v-btn>

        <div>
            <img style="width: 60%; margin-top: 20px;"
                src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/653a934a-9588-4c0a-ba62-468355367785.svg"
                alt="" class=" modal-img" />
            <p class="modal-title">Está tudo certo?</p>
            <p class="modal-subtitle">Atenção que está ação não pode ser desfeita. Ao confirmar, iniciaremos com a contagem
                de sua licença e desbloquearemos uma nova trilha para você.</p>
            <v-btn color="#660099"
                @click="changeProfile()"
                class="text-none btn-action">Comunicar AURA ou Vivo
                Pessoas</v-btn>
        </div>
    </div>
</template>

<script setup>
import { useFelixBagAuxStore, useGlobalStateStore } from '@/store';
import { defineEmits } from 'vue';
import requestApi from '@/utils/requestApi'
defineEmits(["close-modal"])

const globalStateStore = useGlobalStateStore();

const profileOptions = [
  {
    name: 'fui_gestante',
    title: 'Fui Gestante e meu Bebê já nasceu',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/4fcf872c-8e84-450f-9a6b-22ba998bcdd2.svg',
    text: "Seu bebê já chegou? Que maravilha!"
  },
  {
    name: 'parceira_e_bebe_nasceu',
    title: 'Sou parceria e meu bebê já nasceu',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/ab9b9c87-194e-4b16-bae7-993b37cff4fa.svg',
    text: "Seu bebê já chegou? Que maravilha!"
  },
  {
    name: 'processo_adotivo_chegou',
    title: 'Estou em processo adotivo',
    img: '//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/8def483e-54f7-4cdd-ac76-e65fe20fb692.svg',
    text: "Parabéns por esta decisão!"
  }
]

function changeProfile() {
    requestApi({
        url: `/v2/vivo_integration/video/${process.env.VUE_APP_VIDEO_ID}/user/${window.ovmConfig.env['CPF']}/email_colaborador_acionou_mudanca`,
        method: 'POST',
        headers: {
        BCS: globalStateStore.uuid,
        'Content-Type': 'application/json',
        },
        data: {
        "message": "O grande dia chegou"
        }
    }
    ).then(() => {
        if (globalStateStore.globalState.selectedData.profile.name === 'gestante') {
            globalStateStore.globalState.selectedData.profile = profileOptions[0]
        } else if (globalStateStore.globalState.selectedData.profile.name === 'parceria') {
            globalStateStore.globalState.selectedData.profile = profileOptions[1]
        } else if (globalStateStore.globalState.selectedData.profile.name === 'processo_adotivo') {
            globalStateStore.globalState.selectedData.profile = profileOptions[2]
        }
        useFelixBagAuxStore().hideInteractive('solicitar-licensa'); 
        useFelixBagAuxStore().showInteractive('trilha-de-cuidados-final')
    })
}
</script>

<style scoped>
.modal-background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 5;
    background-color: black;
    opacity: 0.4;
}

.modal-container {
    width: 85%;
    position: absolute;
    top: 15%;
    left: 7.5%;
    border-radius: 12px;
    padding: 30px 0;
    background-color: #fff;

    text-align: center;
    z-index: 5;
}

.modal-title {
    color: #464646;
    font-weight: bold;
    width: 85%;
    margin-left: 7.5%;
}

.modal-subtitle {
    font-size: 10px;
    width: 85%;
    margin-left: 7.5%;
    margin-bottom: 20px;
}

.modal-container .btn-action {
    width: 90%;
    font-size: 13px;
}

.close {
    position: absolute;
    width: 30px;
    left: 75%;
    top: 5%;
}
</style>